import React from 'react'
import * as UI from 'ui'
import { Translation } from '@morningtrain/react-translations'

function DiscountChartTooltipInner (props) {
  if (!props) {
    return null
  }

  const employeeFood = !isNaN(parseFloat(props.employee_food_percentage)) ? parseFloat(props.employee_food_percentage) : 0
  const onTheHouse = !isNaN(parseFloat(props.onthehouse_percentage)) ? parseFloat(props.onthehouse_usage) : 0
  const discount = !isNaN(parseFloat(props.discount_percentage)) ? parseFloat(props.discount_percentage) : 0
  const totalRevenue = !isNaN(parseFloat(props.total_revenue)) ? parseFloat(props.total_revenue) : 0

  return (
    <UI.Card>

      <UI.VerticalList>

        <UI.WithSubtitle subtitle={(
          <UI.Text uppercase size='xs'>
            <Translation name='smartviews.schedule_period_summary.revenue' />
          </UI.Text>
        )}
        >
          <UI.Text size='base'>
            {totalRevenue.toLocaleString()} kr.
          </UI.Text>
        </UI.WithSubtitle>

        <UI.WithSubtitle subtitle={(
          <UI.Text uppercase size='xs' className='tracking-wider'>
            <Translation name='economy.pages.discounts.columns.employee_food' />
          </UI.Text>
        )}
        >
          <UI.Text size='sm'>
            {employeeFood.toLocaleString()} kr.
          </UI.Text>
        </UI.WithSubtitle>

        <UI.WithSubtitle subtitle={(
          <UI.Text uppercase size='xs' className='tracking-wider'>
            <Translation name='economy.pages.discounts.columns.onthehouse_food' />
          </UI.Text>
        )}
        >
          <UI.Text size='sm'>
            {onTheHouse.toLocaleString()} kr.
          </UI.Text>
        </UI.WithSubtitle>

        <UI.WithSubtitle subtitle={(
          <UI.Text uppercase size='xs' className='tracking-wider'>
            <Translation name='economy.pages.discounts.columns.discount_food' />
          </UI.Text>
        )}
        >
          <UI.Text size='sm'>
            {discount.toLocaleString()} kr.
          </UI.Text>
        </UI.WithSubtitle>
      </UI.VerticalList>

    </UI.Card>
  )
}

export default React.memo(DiscountChartTooltipInner)
